// routes
import Router from './routes';
import React, { useEffect } from 'react';
// theme
import ThemeProvider from './theme';
//import Settings from './components/settings';
// components
import ScrollToTop from './components/ScrollToTop';
import { BaseOptionChartStyle } from './components/chart/BaseOptionChart';
import { AlterThema } from './contexts/Themas';
import GoogleAnalytics from './components/GoogleAnalytics'; 
import 'swiper/css';
import 'swiper/css/pagination';
// ----------------------------------------------------------------------

export default function App() {
  useEffect(() => {
    const { hostname } = window.location;

    if (hostname === 'sprightly-sopapillas-5d2e9b.netlify.app') {
      window.location.href = 'https://juniorbelem.com' + window.location.pathname + window.location.search;
    }
  }, []);

  return (
    <AlterThema>
      <ThemeProvider> 
             <ScrollToTop />
            <BaseOptionChartStyle />
            <GoogleAnalytics />
            <Router /> 
      </ThemeProvider>
    </AlterThema>
  );
}
